import { useEffect, useContext } from "react";
import { Grid } from "@mui/material";
import styles from "./styles.module.css";
import { ReactComponent as ProfileIcon } from "images/svg/grey_profile.svg";
import SkeletonLoading from "components/utils/Loading/SkeletonLoading";
import Info from "components/utils/Alert/Info";
import SalesPersonContext from "context/SalesPersonContext";

function SalesPerson() {
  const { salesPersons, loadSalesPersons, isLoading } = useContext(SalesPersonContext);

  useEffect(() => {
    loadSalesPersons();
  }, [loadSalesPersons]);

  return (
    <Grid container className={styles.contentWrapper} mt={0} rowGap={2}>
      <Grid item xs={12} className={styles.dataWrapper}>
        <Grid>
          {isLoading ? (
            <SkeletonLoading isOpen={true} count={3} height={56} xs={12} sm={12} md={12} lg={12} />
          ) : salesPersons.length > 0 ? (
            salesPersons.map((salesperson, index) => (
              <Grid key={salesperson?.id || index} item xs={12} className={styles.container}>
                <div className={styles.contentSection}>
                  <ProfileIcon />
                  <h4 className={styles.label}>Name :</h4>
                  <h4 className={styles.value}>{salesperson?.name}</h4>
                </div>
                <div className={styles.divider} />
                <div className={styles.contentSection}>
                  <h5 className={styles.label}>Username :</h5>
                  <h4 className={styles.value}>{salesperson?.username}</h4>
                </div>
              </Grid>
            ))
          ) : (
            <Info title="No Salesperson" content="You have no salesperson to list" />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default SalesPerson;
